import React, {Component} from "react";
import InsertOrderBorrower from "./InsertOrderBorrowerView";
import {CatalogService} from "../../../../service/catalog/CatalogService";
import {OrderBorrowerService} from "../../../../service/ptt/OrderBorrowerService";
import {CatalogDateService} from "../../../../service/catalog/CatalogDateService";
import {ADD_INSTRUMENT_ROUTE, SET_ORDER_BORROWER_ROUTE} from "../../../../utils/constants/RoutesConstants";
import {Growl} from "primereact/growl";
import {validateNumberIntegersDecimals} from "../../../../utils/formatters/Numbers";
import {withoutComma} from "../../../../utils/calculate/Amount";

export default class InsertOrderBorrowerContainer extends Component {
    constructor(props) {
        let today = new Date();
        today.setHours(0, 0, 0, 0);

        super(props);

        this.catalogService = new CatalogService();
        this.catalogDateService = new CatalogDateService();
        this.orderBorrowerService = new OrderBorrowerService();

        this.getCatalogInstrument = this.getCatalogInstrument.bind(this);
        this.saveRadioButtonOption = this.saveRadioButtonOption.bind(this);
        this.insertOrderBorrower = this.insertOrderBorrower.bind(this);
        this.getMaxValueDate = this.getMaxValueDate.bind(this);
        this.getMaturityDate = this.getMaturityDate.bind(this);
        this.newInstrumentScreen = this.newInstrumentScreen.bind(this);
        this.onChangeRate = this.onChangeRate.bind(this);


        this.state = {
            isLoading: true,
            returnPath: this.props.location.state.returnPath,
            today: today,
            catalogInstrument: this.getCatalogInstrument(),
            orderBorrower: {
                catInstrument: [],
                surcharge: 0,
                valueDate: today,
                price: '',
            },
            orderType: "today",
            maxValueDate: this.getMaxValueDate(),
            maturityDate: '',
            validDate: true,
        };

        this.handleReturnButton = this.handleReturnButton.bind(this);
        this.saveDataOrderBorrower = this.saveDataOrderBorrower.bind(this);
    }

    loading(isLoading) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: isLoading
            });
        }
    }

    handleReturnButton() {
        this.props.history.push({
            pathname: this.state.returnPath,
        });
    }

    newInstrumentScreen() {
        this.props.history.push({
            pathname: ADD_INSTRUMENT_ROUTE,
            state: {
                callScreen: 'orderBorrower',
                returnPath: SET_ORDER_BORROWER_ROUTE,
            },
        });
    }

    getMaxValueDate() {
        this.loading(true);
        this.catalogDateService.getMaxValueDate().then(
            valueDate => {
                this.setState({
                    maxValueDate: new Date(valueDate[0])
                })
            });
    }

    getMaturityDate() {
        if (
            this.state.orderBorrower.maturity !== undefined &&
            this.state.orderBorrower.maturity * 1 > 0 &&
            this.state.orderBorrower.valueDate !== undefined
        ) {
            this.loading(true);
            this.catalogDateService.getMaturityDate(
                this.state.orderBorrower.maturity,
                this.state.orderBorrower.valueDate
            ).then(
                maturityDate => {
                    this.setState({
                        isLoading: false,
                        maturityDate: maturityDate[0],
                        validDate: maturityDate[1] === 1
                    })
                });
        }
    }

    getCatalogInstrument() {
        this.loading(true);
        this.catalogService.getCatalogInstrument().then(
            catalogInstrument =>
                this.setState({
                    catalogInstrument: catalogInstrument,
                    isLoading: false
                })
        );
    }

    saveDataOrderBorrower(event) {
        const {name, value} = event.target;
        let orderBorrower = this.state.orderBorrower;
        orderBorrower[name] = value;

        if (name === "maturity") {
            this.getMaturityDate();
        }else if (name === 'valueDate'){
            this.getMaturityDate();
            if(value > this.state.today){
                orderBorrower['price'] = '';
                orderBorrower['disabledRadio'] = true;
            }else{
                orderBorrower['disabledRadio'] = false;
                orderBorrower['price'] = this.state.orderBorrower.copyPrice;
            }
        }else if(name === 'catInstrument'){
            orderBorrower['copyPrice'] = value.precio24 ? value.precio24.toFixed(6) : '';
            if(this.state.orderBorrower.valueDate > this.state.today){
                orderBorrower['price'] = '';
                orderBorrower['disabledRadio'] = true;
            }else{
                orderBorrower['disabledRadio'] = false;
                orderBorrower['price'] = value.precio24 ? value.precio24.toFixed(6) : '';
            }
        }
        this.setState({orderBorrower: orderBorrower,})
    }

    onChangeRate(event){
        const {name, value, id} = event.target;
        let orderBorrower = this.state.orderBorrower;
        let numValue = Number(withoutComma(value));
        orderBorrower[name] = validateNumberIntegersDecimals(numValue, id, 2);
        this.setState({orderBorrower: orderBorrower,})
    }

    saveRadioButtonOption(event) {
        this.setState({
            orderType: event.value,
        });
    }

    validateOrder() {
        let msgError = '';

        if (!this.state.validDate) {
            msgError = "El Plazo es incorrecto ya que el vencimiento no puede ser sábado, domingo o en día festivo";
        } else {
            let fields = [];

            if (this.state.orderBorrower.catInstrument.idEmisora === undefined) {
                fields.push("Emisora");
            }

            if (this.state.orderBorrower.amount === undefined || this.state.orderBorrower.amount === "" || this.state.orderBorrower.amount === "0") {
                fields.push("Títulos");
            }

            if (this.state.orderBorrower.rate === undefined || this.state.orderBorrower.rate === "") {
                fields.push("Tasa");
            }

            if (this.state.orderBorrower.surcharge === undefined || this.state.orderBorrower.surcharge === "") {
                fields.push("SobreTasa");
            }

            if (this.state.orderBorrower.maturity === undefined || this.state.orderBorrower.maturity === "" || this.state.orderBorrower.maturity === "0") {
                fields.push("Plazo");
            }

            if (this.state.orderBorrower.valueDate === undefined || this.state.orderBorrower.valueDate === "") {
                fields.push("Fecha Valor");
            }

            if (fields.length > 0) {
                msgError = "Favor de revisar los siguientes campos: ";

                fields.map(field => {
                    msgError = msgError + field + ', ';
                    return '';
                });
            }
        }

        return msgError;
    }

    insertOrderBorrower() {
        let msg = this.validateOrder();
        if (msg !== '') {
            this.growl.show({
                severity: 'error',
                summary: 'Error.',
                detail: msg
            });
            return '';
        }

        this.loading(true);
        this.orderBorrowerService.insertOrderBorrower(this.state.orderBorrower, this.state.orderType
        ).then(resp => {
            let message = {};
            if (resp.error !== '') {
                message = {
                    severity: 'error',
                    summary: 'Error.',
                    detail: resp.error.replace(/%/g, '')};
            } else {
                message = {
                    severity: 'success',
                    summary: 'Éxito',
                    detail: 'La acción se ha realizado correctamente',
                };
            }

            this.setState({isLoading: false,});
            this.props.history.push({
                pathname: this.state.returnPath,
                message: message,
            });
        });
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;

        return <InsertOrderBorrower
            isLoading={this.state.isLoading}
            loading={this.loading}
            messagesGrowl={messagesGrowl}
            catalogInstrument={this.state.catalogInstrument}
            handleReturnButton={this.handleReturnButton}
            newInstrumentScreen={this.newInstrumentScreen}
            saveDataOrderBorrower={this.saveDataOrderBorrower}
            orderBorrower={this.state.orderBorrower}
            saveRadioButtonOption={this.saveRadioButtonOption}
            orderType={this.state.orderType}
            insertOrderBorrower={this.insertOrderBorrower}
            today={this.state.today}
            maxValueDate={this.state.maxValueDate}
            maturityDate={this.state.maturityDate}
            validDate={this.state.validDate}
            onChangeRate={this.onChangeRate}
        />
    }
}